import React, { useState, useEffect } from 'react'
// import Pagination from '@mui/material/Pagination';
import Loader from '../../../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../../../images/nodata.png';
import { getOEMBatteryDetails } from '../../Community/CommunityActionCreator';
import { Callbacks } from 'jquery';
import Pagination from '../../Community/TablePagination'
import { paginationFuction } from '../../CommonUtils';
const itemsPerPage = 10;
export default function OEMtable({ handleTab }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([]);
    const [data, setData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);

    useEffect(() => {
        getOEMBatteryDetailsFunction()
    }, [])

    const getOEMBatteryDetailsFunction = () => {
        setLoader(true)
        getOEMBatteryDetails((callback) => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                settableData(callback?.data)
                updatePageData(callback.data, 1);
            } else {
                settableData([])
                setData([])
            }
        })
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        updatePageData(tableData, value);
    }

    const updatePageData = (datas, page) => {

        const indexOfLastItem = (page) * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = datas && datas?.length > 0 ? datas?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setData(currentItems)
    };

    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, tableData?.length, callBack => {
            console.log(callBack, 'callback')
            setcurrentPage(callBack)
            updatePageData(tableData, callBack)
        })
    }

    const getDatefn = (timestamp)=>{
        if(timestamp == "" || timestamp == undefined || timestamp == null){
            return "-"
        }else{

            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');     
            const month = String(date.getMonth() + 1).padStart(2, '0'); 
            const year = date.getFullYear();
            
            return `${day}-${month}-${year}`;
        }
    }


    return (
        <>
            <div className="communitySection">
                <div className='container-fluid' style={{ marginTop: '20px' }}>
                    {
                        loader ?
                            <Loader />
                            : ''}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0px 0 30px 0' }}>
                        <h3>Battery OEM</h3>
                        <button
                            className='cred-btn'
                            onClick={e => handleTab('addEdit')}
                            style={{ padding: '14px 15px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>

                    </div>
                    {
                        data && data?.length > 0 ?
                            <div className='table-responsive full-height'>
                                <div className="">
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table' style={{ boxShadow: '0 1px 2px 0 rgba(60, 64, 67, 0.302), 0 1px 3px 1px rgba(60, 64, 67, 0.149)' }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-center">OEM Id</th>
                                                    <th scope="col" className="text-center">OEM Name</th>
                                                    <th scope="col" className="text-center">Weightage</th>
                                                    <th scope="col" className="text-center">Added On</th>
                                                    
                                                    <th scope="col" className="text-center">Edit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((data, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.batteryOemId || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.oemName || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.weightage || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{getDatefn(data?.addedOn) || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>
                                                                <button className='btn action-btn' onClick={e => handleTab('addEdit', data)}>
                                                                    <i className='fa fa-edit' />
                                                                </button>
                                                            </td>


                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div style={{ float: 'right', marginTop: '20px' }}>
                                    <Pagination
                                        count={Math.ceil(tableData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div> */}
                                    <Pagination

                                        paginationHandlerNew={paginationHandlerNew}
                                        totalCount={tableData?.length}
                                        pageNumber={currentPage}
                                        noOfRows={itemsPerPage}
                                    />
                                </div>
                            </div>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '50%' }} alt="No data available" />
                            </p>
                    }

                </div>
            </div>
        </>
    )
}
